import PropTypes from 'prop-types';
import React from 'react';
import {getUserById} from 'state/user/userSelectors';
import {load} from 'state/user/userActions';
import {connect} from 'react-redux';
import {NBSP} from 'utilities/DOM';

class DisplayName extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.load(this.props.userId);
  }

  render() {
    const {user, style, className} = this.props;
    return (
      <span style={style} className={className}>
        {user ? user.displayName : NBSP}
      </span>
    );
  }
}

DisplayName.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default connect(
  (state, props) => ({
    user: getUserById(state, props.userId),
  }),
  {
    load,
  }
)(DisplayName);
